import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-board",
  "use": "icon-board-usage",
  "viewBox": "0 0 506.9 506.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 506.9 506.9\" id=\"icon-board\">\n<desc></desc>\n<path d=\"M253.5,0C113.5,0,0,113.5,0,253.5s113.5,253.5,253.5,253.5s253.5-113.5,253.5-253.5S393.5,0,253.5,0z M395.1,168.5h-28.3\n\tv170h-99.1v28.3h-28.3v-28.3h-99.1v-170h-28.3v-28.3h28.3h226.6h28.3V168.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol